module.exports = __webpack_public_path__ + "static/media/ic-call-outline.cf694ad0.png";